import React from "react";

const AnalyticsPage = () => {
  return <div>This is the Analytics Page</div>;
};

export default AnalyticsPage;
